import { Center } from "@mantine/core"
import { Button, Modal, Text } from "components"
import { IRootState } from "config/redux";
import { ServiceConstants } from "constant";
import { TFunction } from "i18next";
import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { CreditService } from "services";
import { CreditRequestPayment } from "types"

const { REQUEST_CREDIT_PAYMENT_DELETE_ID, REQUEST_PENDING } = ServiceConstants;

interface DeleteModalProps {
  item: CreditRequestPayment;
  opened: boolean;
  onClose: () => void;
  t: TFunction;
}

const DeleteModal = ({ item, opened, onClose, t }: DeleteModalProps) => {
  const serviceObject = useSelector((state: IRootState) => state.service.object[REQUEST_CREDIT_PAYMENT_DELETE_ID + item.id]);

  const deletePayment = useCallback(() => CreditService.creditPaymentDelete(item.id), [item.id]);
  const isLoading = useMemo(() => serviceObject && serviceObject.status === REQUEST_PENDING, [serviceObject]);

  return (
    <Modal opened={opened} onClose={onClose} title={t('credit.payment.delete.title')}>
      <Text ta={'center'} my={24}>{t('credit.payment.delete.confirm')}</Text>
      <Center mt={32}>
        <Button onClick={deletePayment} disabled={isLoading}>
          <Text>{t('action.delete')}</Text>
        </Button>
      </Center>
    </Modal>
  )
}

export default DeleteModal;